import { noop } from 'lodash';
import { httpCreators, HttpResponse, Tags } from 'rbh-merchant-core';
import { call, put, takeLatest } from 'redux-saga/effects';
import { generalCreators } from '../../../../redux/general/general-action';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { generalSagas } from '../../../../redux/general/general-saga';
import { history } from '../../../../router';
import { foodMenuSagas } from '../../FoodMenu/redux/foodmenu-saga';
import { catCreators } from './cat-action';
import { CAT_INLINE_ERROR, CAT_REQUEST_ID_LIST, CAT_TRANSLATION_KEY } from './cat-constant';
import { CAT_STATE_KEY } from './cat-reducer';
import { CatService } from './cat-service';
import { CallFoodCategoryAction, CAT_ACTION_TYPE } from './cat-type';

function* callFoodCategory(action: CallFoodCategoryAction) {
  yield put(httpCreators.request({
    id: CAT_REQUEST_ID_LIST.GET_CAT,
    sagaHandler: getFoodCategoryHandler,
    service: CatService.getCat,
    callbackParams: { action }
  }));
  yield call(generalSagas.callTnc);
}

function* getFoodCategoryHandler(resp: HttpResponse, callbackParams: { action: CallFoodCategoryAction }) {
  const { onFailureCallback, isAddCategoryPage, onSuccessCallback } = callbackParams.action.payload;
  if (resp.success) {
    yield put(catCreators.setCatState(CAT_STATE_KEY.LIST, resp.data.menuCategories as []));
    if (!isAddCategoryPage) {
      yield call(foodMenuSagas.callGetMenuTags, onFailureCallback, onSuccessCallback)
    }
  } else {
    yield put(catCreators.setCatState(CAT_STATE_KEY.LIST, undefined));
    if (!isAddCategoryPage) {
      yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
        visible: true,
        onOk: onFailureCallback,
        type: MODAL_TYPE.ERROR
      }));
    }
  }
}

function* postCatHandler(
  resp: HttpResponse,
  callbackParams: {
    onSuccessCallback: () => void,
    setFieldError: (fieldName: string, errorShow: string[]) => void
  }) {
  if (resp.success) {
    yield call(callbackParams.onSuccessCallback);
  } else if (resp.statusCode === 1799 && resp.data?.translationKey) {
    for (const key of resp.data?.translationKey) {
      if (key === CAT_TRANSLATION_KEY.MENU_CATEGORY_NAME_TH_DUP) {
        yield call(callbackParams.setFieldError, 'menuCategoryName', [CAT_INLINE_ERROR.MENU_CATEGORY_NAME_DUP]);
      } else if (key === CAT_TRANSLATION_KEY.MENU_CATEGORY_NAME_EN_DUP) {
        yield call(callbackParams.setFieldError, 'menuCategoryNameEN', [CAT_INLINE_ERROR.MENU_CATEGORY_NAME_DUP]);
      }
    }
  } else if (resp.statusCode === 1899) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => {
        history.goBack();
      },
      type: MODAL_TYPE.ERROR
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* patchCatHandler(
  resp: HttpResponse,
  callbackParams: {
    onSuccessCallback: () => void,
    setFieldError: (fieldName: string, errorShow: string[]) => void,
    onNotificationError: () => void,
    editFrom: any,
    editTo: any,
  }) {
  if (resp.success) {
    yield call(callbackParams.onSuccessCallback);
    yield put(catCreators.setCatState(CAT_STATE_KEY.ALERT_SUCCESS, {
      isVisible: true,
      translationValues: {
        categoryName: callbackParams.editTo.menuCategoryName,
      },
    }));
  } else if (resp.statusCode === 1799 && resp.data?.translationKey) {
    for (const key of resp.data?.translationKey) {
      if (key === CAT_TRANSLATION_KEY.MENU_CATEGORY_NAME_TH_DUP) {
        yield call(callbackParams.setFieldError, 'menuCategoryName', [CAT_INLINE_ERROR.MENU_CATEGORY_NAME_DUP]);
      } else if (key === CAT_TRANSLATION_KEY.MENU_CATEGORY_NAME_EN_DUP) {
        yield call(callbackParams.setFieldError, 'menuCategoryNameEN', [CAT_INLINE_ERROR.MENU_CATEGORY_NAME_DUP]);
      }
    }
  } else if (resp.statusCode === 1899) {
    yield call(callbackParams.onNotificationError);
    yield put(catCreators.setCatState(CAT_STATE_KEY.ALERT_FAILURE, {
      isVisible: true,
      translationValues: {
        categoryName: callbackParams.editFrom.menuCategoryName,
      },
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* deleteCatHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    callbackParams();
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

export const catSagas = {
  callFoodCategory,
  getFoodCategoryHandler,
  postCatHandler,
  patchCatHandler,
  deleteCatHandler,
  watchers: [
    takeLatest(CAT_ACTION_TYPE.CALL_FOOD_CATEGORY, callFoodCategory)
  ]
};


